export default __webpack_public_path__ + "static/media/ai_color_detection.3dcac775.svg";